module.exports = __webpack_public_path__ + "media/images/official/removeanxieties_graph3-a9325cad37cb6e543aa4edc874ecc062.png";